import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import MediaQuery from 'react-responsive';
import ReviewsHeader from './reviews_header/ReviewsHeader';
import Review from './review/Review';
import { REVIEW_CONSTANTS } from '../../constants';
import MODALS from '../../../modals/constants/modals';
import SubmitReviewForm from './submit_review_form/SubmitReviewForm';
import { reviewsActions } from '../../actions';
import { userObjectSelector } from '../../../user/selectors/user';
import { modalsActions } from '../../../modals/actions';
import Button from '../../../ui_kit/button/Button';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import {
  pageSelector, currentPageSelector, totalPagesSelector,
  totalReviewsSelector, entriesSelector, ratingSelector, reviewsLoadingSelector,
} from '../../selectors/reviews';
import { reviewSubmittedSelector } from '../../selectors/review_form';
import closeIcon from '../../../../images/icons/close.svg';
import './ReviewsSection.sass';

const DESKTOP_WIDTH_BREAKPOINT = 600;
const DULL_LAVENDAR_COLOR = '#9DACE4';

class ReviewsSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitReviewMode: props.submitReviewMode || false,
    };
  }

  componentDidMount() {
    const { reviewsLoadRequest, sourceId, isCampaign } = this.props;
    reviewsLoadRequest(
      {
        page: REVIEW_CONSTANTS.DEFAULT_PAGE,
        perPage: REVIEW_CONSTANTS.DEFAULT_PER_PAGE,
        isCampaign,
        sourceId,
      },
    );
  }

  toggleReviewMode = () => {
    this.setState((prevState) => ({
      submitReviewMode: !prevState.submitReviewMode,
    }));
  };

  writeReviewClickHandler = () => {
    const { user, openSignUpModal, isCampaign } = this.props;
    if (!isCampaign) { return this.toggleReviewMode(); }

    if (!user) {
      Cookies.set('signed_up_from', 'campaign_comments');
      return openSignUpModal();
    }

    return this.toggleReviewMode();
  };

  isLastPage = () => {
    const { currentPage, perPage = 2, totalReviews = 0 } = this.props;

    const totalPages = Math.ceil(totalReviews / perPage);
    return (currentPage === totalPages);
  };

  loadMore = () => {
    const {
      setCurrentPage, currentPage, reviewsLoadRequest, reviews, sourceId, page,
      isCampaign, perPage = 2,
    } = this.props;

    if (this.isLastPage()) return;

    if (currentPage * perPage >= reviews.length) {
      reviewsLoadRequest({
        perPage: REVIEW_CONSTANTS.DEFAULT_PER_PAGE, sourceId, page, isCampaign,
      });
    }
    setCurrentPage(currentPage + 1);
  };

  render() {
    const { submitReviewMode } = this.state;
    const {
      reviews, totalReviews = 0, currentPage, rating = 0, sourceId, loading, reviewSubmitted,
      isCampaign, customColor = DULL_LAVENDAR_COLOR, customTransparentButtonStyles,
      customFullButtonStyle, perPage = 2,
      openImageModal,
    } = this.props;

    const totalPages = Math.ceil(totalReviews / perPage);
    const isReviewsPresent = reviews.length > 0;

    return (
      <div className="reviews-container">
        <div className={`title ${isCampaign ? 'campaign' : ''}`} style={{ color: customColor }}>
          { isCampaign ? 'DISCUSSION' : 'REVIEWS' }
        </div>
        <style>{customTransparentButtonStyles}</style>
        <style>{customFullButtonStyle}</style>
        <div className="reviews-header-and-button">
          { !isCampaign && (
            <ReviewsHeader
              customColor={customColor}
              rating={rating}
              reviewsCount={totalReviews}
            />
          )}
          <MediaQuery query={`(min-width: ${DESKTOP_WIDTH_BREAKPOINT}px)`}>
            {!submitReviewMode && (
              <Button
                className={`write-review ${isCampaign ? 'campaign' : ''} custom-transparent-button`}
                text={isCampaign ? 'Leave A Comment' : 'Write A Review'}
                size="small"
                color="transparent-blue"
                onClickHandler={this.writeReviewClickHandler}
              />
            )}
          </MediaQuery>
        </div>
        <MediaQuery query={`(min-width: ${DESKTOP_WIDTH_BREAKPOINT}px)`}>
          { submitReviewMode && !reviewSubmitted && (
            <div className={`form-container ${isCampaign ? 'campaign' : ''}`}>
              <ClickableDiv className="close" type="button" onClick={this.toggleReviewMode}>
                <img alt="close" src={closeIcon} />
              </ClickableDiv>
              <SubmitReviewForm
                userLoggedIn={!!window.store.getState().user}
                sourceId={sourceId}
                isCampaign={isCampaign}
                customColor={customColor}
                customFullButtonStyle={customFullButtonStyle}
              />
            </div>
          )}
        </MediaQuery>
        { !isReviewsPresent && !submitReviewMode && (
        <div className="empty-reviews">
          <div className="no-reviews">
            { isCampaign && 'No comments on this campaign yet.'}
            { !isCampaign && 'No reviews on this product yet.'}
          </div>
          <div className="be-the-first">
            Be the first!
          </div>
          <ClickableDiv
            className="write-a-review"
            style={{ color: customColor }}
            onClick={this.writeReviewClickHandler}
          >
            Write A Review
          </ClickableDiv>
        </div>
        )}
        <div className="reviews">
          { isReviewsPresent && reviews.slice(0, currentPage * perPage).map((review) => (
            <Review
              key={review.id}
              review={review}
              isCampaign={isCampaign}
              customColor={customColor}
              openImageModal={openImageModal}
            />
          ))}
        </div>
        { isReviewsPresent && totalPages > 1 && (
          <div className="load-more">
            { totalPages >= 2 && !this.isLastPage() && (
            <Button
              className="custom-button"
              text="show more"
              onClickHandler={this.loadMore}
              loading={loading}
              color="blue"
              size="small"
            />
            )}
          </div>
        )}
        <MediaQuery query={`(max-width: ${DESKTOP_WIDTH_BREAKPOINT - 1}px)`}>
          {!submitReviewMode && isReviewsPresent && (
            <Button
              className="write-review custom-transparent-button"
              text={isCampaign ? 'Leave A Comment' : 'Write A Review'}
              size="small"
              color="transparent-blue"
              onClickHandler={this.writeReviewClickHandler}
            />
          )}
          { submitReviewMode && !reviewSubmitted && (
            <div className={`form-container ${isCampaign ? 'campaign' : ''}`}>
              <ClickableDiv className="close" type="button" onClick={this.toggleReviewMode}>
                <img alt="close" src={closeIcon} />
              </ClickableDiv>
              <SubmitReviewForm
                userLoggedIn={!!window.store.getState().user}
                sourceId={sourceId}
                isCampaign={isCampaign}
                customColor={customColor}
                customFullButtonStyle={customFullButtonStyle}
              />
            </div>
          )}
        </MediaQuery>
      </div>
    );
  }
}

ReviewsSection.propTypes = {
  sourceId: PropTypes.string.isRequired,
  isCampaign: PropTypes.bool,
  reviewsLoadRequest: PropTypes.func.isRequired,
  reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  totalReviews: PropTypes.number,
  page: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  rating: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  reviewSubmitted: PropTypes.bool,
  customTransparentButtonStyles: PropTypes.string,
  customFullButtonStyle: PropTypes.string,
  customColor: PropTypes.string,
  user: PropTypes.shape({
    sign_in_count: PropTypes.number,
    confirmed_at: PropTypes.string,
  }),
  openSignUpModal: PropTypes.func.isRequired,
  perPage: PropTypes.number,
  openImageModal: PropTypes.func.isRequired,
  submitReviewMode: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  reviews: entriesSelector(state),
  totalReviews: totalReviewsSelector(state),
  rating: ratingSelector(state),
  currentPage: currentPageSelector(state),
  page: pageSelector(state),
  loading: reviewsLoadingSelector(state),
  reviewSubmitted: reviewSubmittedSelector(state),
  totalPages: totalPagesSelector(state),
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  reviewsLoadRequest: (params) => dispatch(reviewsActions.reviewsLoadRequest(params)),
  setCurrentPage: (page) => dispatch(reviewsActions.setCurrentPage(page)),
  openSignUpModal: () => dispatch(modalsActions.openModalRequest({
    modal: MODALS.SIGN_UP_FOR_COMMENTING,
  })),
  openImageModal: (imageUrl) => dispatch(modalsActions.openModalRequest({
    modal: MODALS.IMAGE_WITH_ZOOM,
    data: { imageUrl },
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewsSection);
